import { render, staticRenderFns } from "./appointRole.vue?vue&type=template&id=658614b6&scoped=true&"
import script from "./appointRole.vue?vue&type=script&lang=js&"
export * from "./appointRole.vue?vue&type=script&lang=js&"
import style0 from "./appointRole.vue?vue&type=style&index=0&id=658614b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658614b6",
  null
  
)

export default component.exports